import { Icon } from '@types';

export const MeterHouse = ({ customStyles, handleClick }: Icon) => {
	return (
		<svg
			className={customStyles}
			onClick={handleClick}
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			width="17.559"
			height="16.966"
			viewBox="0 0 17.559 16.966"
		>
			<defs>
				<clipPath id="clip-path-meter">
					<path
						id="Path_4551"
						data-name="Path 4551"
						d="M122.25,112.5h11.864v13.637H122.25Zm0,0"
						transform="translate(-122.25 -112.5)"
					/>
				</clipPath>
				<clipPath id="clip-path-meter-2">
					<path
						id="Path_4300"
						data-name="Path 4300"
						d="M112.5,122.719h7.7v6.657h-7.7Zm0,0"
						transform="translate(-112.5 -122.719)"
					/>
				</clipPath>
			</defs>
			<g id="Group_4302" data-name="Group 4302" transform="translate(-18677.137 -15982.073)">
				<g
					id="_1"
					data-name="1"
					transform="translate(18677.137 15985.402)"
					clipPath="url(#clip-path-meter)"
				>
					<path
						id="Path_4550"
						data-name="Path 4550"
						d="M133.461,125.508a.07.07,0,0,1-.071.07h-3.079a.071.071,0,0,1-.071-.07V120.78a.792.792,0,0,0-.791-.791h-2.381a.792.792,0,0,0-.791.791v4.729a.07.07,0,0,1-.07.07h-3.079a.07.07,0,0,1-.07-.07V119.03l-.013-.517a.425.425,0,0,1,.132-.319l5.012-4.756a.071.071,0,0,1,.049-.019.069.069,0,0,1,.049.02l5.029,4.772a.423.423,0,0,1,.132.3l.014.535Zm-11.123,0a.792.792,0,0,0,.791.791h3.079a.792.792,0,0,0,.791-.791V120.78a.071.071,0,0,1,.071-.071h2.381a.071.071,0,0,1,.071.071v4.729a.792.792,0,0,0,.791.791h3.079a.792.792,0,0,0,.791-.791V119.03l-.014-.541a1.137,1.137,0,0,0-.357-.8l-5.029-4.772a.791.791,0,0,0-1.089,0l-5.012,4.756a1.147,1.147,0,0,0-.356.86l.013.511v6.465"
						transform="translate(-122.317 -112.681)"
					/>
				</g>
				<g
					id="Untitled_design_7_"
					data-name="Untitled design (7)"
					transform="translate(18574.5 15859.354)"
				>
					<g
						id="Group_4163"
						data-name="Group 4163"
						transform="translate(112.5 122.719)"
						clipPath="url(#clip-path-meter-2)"
					>
						<path
							id="Path_4299"
							data-name="Path 4299"
							d="M116.526,122.73a3.846,3.846,0,0,0-2.715,6.562.35.35,0,0,0,.485,0l.824-.825a.343.343,0,1,0-.485-.485l-.573.575a3.111,3.111,0,0,1-.671-1.643h.8a.34.34,0,0,0,0-.68h-.808a3.084,3.084,0,0,1,.679-1.635l.566.566a.349.349,0,0,0,.485,0,.352.352,0,0,0,0-.485l-.566-.567a3.108,3.108,0,0,1,1.632-.68v.81a.339.339,0,1,0,.679,0v-.81a3.165,3.165,0,0,1,2.8,2.8h-.808a.34.34,0,0,0,0,.68h.8a2.984,2.984,0,0,1-.654,1.643l-.574-.575a.343.343,0,1,0-.485.485l.824.825a.35.35,0,0,0,.485,0,3.846,3.846,0,0,0-2.715-6.562"
							transform="translate(-112.678 -122.729)"
						/>
					</g>
					<path
						id="Path_4301"
						data-name="Path 4301"
						d="M174.913,163.917a.247.247,0,0,0-.333-.063l-1.561,1.08a.751.751,0,0,0-.149.149.592.592,0,1,0,.972.675l1.078-1.562a.247.247,0,0,0-.007-.277"
						transform="translate(-56.994 -38.832)"
					/>
				</g>
			</g>
		</svg>
	);
};
